import { RuleId } from '@wix/a11y-rules';
import { normalizeElementKey } from '../../verticals-drill-in/get-cross-color-contrast-issues/normalize-element-key';
export const getSpecificPageIssueResults = (executionResults, crossPageIssues, crossPageColorContrastIssuesInSession, tpaPageId) => {
  const {
    crossPagesHeadingStructureIssues,
    crossPagesColorContrastIssues
  } = crossPageIssues;
  const specificPageResults = [];
  const ruleHandlers = {
    [RuleId.VALID_STATIC_PAGE_TITLE]: results => results,
    [RuleId.HEADING_STRUCTURE]: results => crossPagesHeadingStructureIssues ? [] : results,
    [RuleId.COLOR_CONTRAST]: results => results.map(result => {
      var _result$metadata, _crossPageResult$resu, _result$result, _result$result2;
      if (!((_result$metadata = result.metadata) != null && _result$metadata.breakpointId) || !(crossPagesColorContrastIssues != null && crossPagesColorContrastIssues[result.metadata.breakpointId])) {
        return result;
      }
      const crossPageResult = crossPagesColorContrastIssues[result.metadata.breakpointId];
      const crossPageElementKeys = new Set([...crossPageColorContrastIssuesInSession, ...(((_crossPageResult$resu = crossPageResult.result) == null || (_crossPageResult$resu = _crossPageResult$resu.failedElements) == null ? void 0 : _crossPageResult$resu.map(element => normalizeElementKey(element))) || [])]);
      const newFailedElements = ((_result$result = result.result) == null || (_result$result = _result$result.failedElements) == null ? void 0 : _result$result.filter(element => !crossPageElementKeys.has(normalizeElementKey(element)))) || [];
      return {
        ...result,
        result: {
          ...result.result,
          failedElements: newFailedElements,
          status: newFailedElements.length === 0 ? 'passed' : (_result$result2 = result.result) == null ? void 0 : _result$result2.status
        }
      };
    }),
    [RuleId.STATIC_ALT_TEXT]: () => [],
    [RuleId.MEDIA_ALTERNATIVES]: tpaPageId ? results => results.filter(res => {
      var _res$metadata;
      return ((_res$metadata = res.metadata) == null ? void 0 : _res$metadata.pageId) !== tpaPageId;
    }) : () => [],
    [RuleId.INACCESSIBLE_COMPONENTS]: () => []
  };
  Object.values(executionResults).forEach(ruleDict => {
    for (const [ruleId, ruleResults] of Object.entries(ruleDict)) {
      const typedRuleId = ruleId;
      const handler = ruleHandlers[typedRuleId];
      if (handler) {
        specificPageResults.push(...handler(ruleResults));
      }
    }
  });
  return specificPageResults.filter(result => {
    var _result$result3;
    return ((_result$result3 = result.result) == null ? void 0 : _result$result3.status) !== 'error';
  });
};
//# sourceMappingURL=get-specific-page-issue-results.js.map